/**
 * App Configuration - Fokus
 * 
 * Visual project management with flowchart-based task planning
 */

// API URL must be set via environment variable in Amplify
// - Staging: REACT_APP_FOKUS_API_URL = https://xxx.execute-api.eu-west-2.amazonaws.com/staging
// - Production: REACT_APP_FOKUS_API_URL = https://yyy.execute-api.eu-west-2.amazonaws.com/prod
const apiUrl = process.env.REACT_APP_FOKUS_API_URL;

if (!apiUrl) {
  console.error('❌ REACT_APP_FOKUS_API_URL environment variable is not set!');
}

export const APP_CONFIG = {
  // App identifier
  appName: 'Fokus',
  
  // API URL - must be configured per environment (no fallback)
  apiUrl: apiUrl || '',

  // Brain Function URL (streamed). CRA only sees REACT_APP_* from
  // `.env.local` / a restarted `npm start`, so local falls back to staging.
  brainUrl: (
    process.env.REACT_APP_BRAIN_URL ||
    (process.env.NODE_ENV === 'development'
      ? 'https://tqngihnvwynahcisa3h4argq440xfjnu.lambda-url.eu-west-2.on.aws'
      : '')
  ).replace(/\/$/, ''),
};

export default APP_CONFIG;
